export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7379.09c05971.jpg";